import { getConfig } from '../EnvConfig'

import { InvokeAnalyticsAPIPayload } from './types'

export const invokeAnalyticsAPI = async (
  invokeAnalyticsAPIPayload: InvokeAnalyticsAPIPayload
): Promise<void> => {
  const { endpoint, accessToken, method, body } = invokeAnalyticsAPIPayload

  const baseURL = getConfig()?.ANALYTICS_API_BASE_URL
  const url = `${baseURL}${endpoint}`

  try {
    // use fetch to leverage keepalive option as it is not reliable in axios and unavailable with lambda api client
    await fetch(url, {
      method,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body),
      keepalive: true
    })
  } catch (error) {
    console.error(`Error invoking analytics API: ${error?.message}`)
  }
}
